export const SITE_LOGO_PATH = '/logo-horizontal.png';
